import { useEffect } from "react"
import { EyeIcon } from "../../../ui/icons/eye"
import { SelectCustom } from "../../../ui/molecules/select"
import { AccordionFilter } from "../../../ui/organisms/accordionFilter"
import { FindAllContactsFilters } from "../dto"
import { Wallet01Icon } from "../../../ui/icons/wallet01"

interface Props {
    updateFilters: (filter: Partial<FindAllContactsFilters>) => void
    filters: FindAllContactsFilters
    clearAll: boolean
}

export function EcommerceFilter(props: Props) {
    const { updateFilters, filters } = props
    const options = [
        { value: 'true', label: 'Sì' },
        { value: 'false', label: 'No' }
    ]

    useEffect(() => {
        if (props.clearAll) {
            updateFilters({ companyEcommerce: undefined })
        }
    }, [props.clearAll]);
    return (
        <AccordionFilter
            key={'company-filter-ecommerce'}
            label={"E-commerce"}
            icon={<Wallet01Icon color={""} size={0} />}
            showClear={filters.companyEcommerce !== undefined}
            options={filters.companyEcommerce !== undefined ? [filters.companyEcommerce] : []}
            clearAction={function (): void {
                updateFilters({ companyEcommerce: undefined })
            }}
            deleteFilter={function (option): void {
                updateFilters({ companyEcommerce: undefined })
            }}
        >
            <SelectCustom
                isSearchable={false}
                isClearable
                onChange={e => {
                    if (e === undefined) {
                        updateFilters({ companyEcommerce: undefined })
                    } else if (typeof e === 'string') {
                        updateFilters({ companyEcommerce: { value: e, label: options.find(opt => opt.value === e)?.label! } })
                    }
                }}
                defaultValue={filters.companyEcommerce?.value}
                placeholder={"E-commerce"}
                options={options}
            />
        </AccordionFilter>
    )
}